import React from 'react'

import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { compose, setPropTypes } from 'recompose'
import createClassNames from 'classnames'

import { withStyles } from '@material-ui/core/styles'
import MuiMenuItem from '@material-ui/core/MenuItem'
import MuiTypography from '@material-ui/core/Typography'

import theme from 'app/theme'

const styles = {
  item: {
    padding: '8px 16px',
    textDecoration: 'none',
    '& > svg': {
      fontSize: 18,
      marginRight: 9,
      color: theme.palette.secondary.main
    },
    '& > p': {
      fontWeight: 400,
      color: theme.palette.secondary.main
    }
  },
  activeItem: {
    '& > svg': {
      color: theme.palette.primary.main
    },
    '& > p': {
      fontWeight: 500,
      color: theme.palette.primary.main
    }
  }
}

const MenuItem = ({ classes, icon, text, active, ...props }) => {
  const itemProps = { ...props }
  if (props.to) itemProps.component = Link

  const classNames = createClassNames(classes.item, { [classes.activeItem]: active })

  return (
    <MuiMenuItem className={classNames} {...itemProps}>
      {icon ? icon : ''}
      {text && <MuiTypography variant="body2">{text}</MuiTypography>}
    </MuiMenuItem>
  )
}

const enhance = compose(
  withStyles(styles),
  setPropTypes({
    icon: PropTypes.node,
    text: PropTypes.string,
    link: PropTypes.string,
    color: PropTypes.string
  })
)

export default enhance(MenuItem)
